<template>
<section class="audit-wrapper">
  <audit-main :max-audit-stage="maxAuditStage" :query="query" />
  <audit-pm-device :max-audit-stage="maxAuditStage" :query="query" :importance-device-status="importanceDeviceStatus" />
  <audit-v-o-c-device :max-audit-stage="maxAuditStage" :query="query" :importance-device-status="importanceDeviceStatus" />
  <audit-ion-device :max-audit-stage="maxAuditStage" :query="query" :importance-device-status="importanceDeviceStatus" />
  <audit-oc-ec-device :max-audit-stage="maxAuditStage" :query="query" :importance-device-status="importanceDeviceStatus" />
  <audit-heavy-metal-device :max-audit-stage="maxAuditStage" :query="query" :importance-device-status="importanceDeviceStatus" />
  <audit-radar-device :max-audit-stage="maxAuditStage" :query="query" />
  <audit-particle-size-spectrum-device :max-audit-stage="maxAuditStage" :query="query" />
  <audit-wind-profile-device :max-audit-stage="maxAuditStage" :query="query" />
  <audit-normal-device :max-audit-stage="maxAuditStage" :query="query" :importance-device-status="importanceDeviceStatus" />
</section>
</template>

<script>
import AuditMain from './AuditMain'
import BaseStore from '../../../components/BaseStore'
import AuditNormalDevice from './AuditDeviceViews/AuditNormalDevice'
import AuditVOCDevice from './AuditDeviceViews/AuditVOCDevice'
import AuditRadarDevice from './AuditRadarDevice'
import AuditWindProfileDevice from './AuditWindProfileDevice'
import AuditParticleSizeSpectrumDevice from './AuditParticleSizeSpectrumDevice'
import AuditIonDevice from './AuditDeviceViews/AuditIonDevice'
import AuditOcEcDevice from './AuditDeviceViews/AuditOcEcDevice'
import AuditPmDevice from './AuditDeviceViews/AuditPmDevice'
import AuditHeavyMetalDevice from './AuditDeviceViews/AuditHeavyMetalDevice'

export default {
  name: 'DataAuditManual',
  routeInfo: {
    label: '人工审核',
    icon: 'fa fa-eye'
  },
  extends: BaseStore,
  components: {
    AuditHeavyMetalDevice,
    AuditPmDevice,
    AuditOcEcDevice,
    AuditIonDevice,
    AuditParticleSizeSpectrumDevice,
    AuditWindProfileDevice,
    AuditRadarDevice,
    AuditNormalDevice,
    AuditVOCDevice,
    AuditMain
  },
  data () {
    let date = new Date()
    date.setDate(date.getDate() - 1)

    return {
      maxAuditStage: 0,
      query: {
        auditTime: date.format('YYYY/MM/DD'),
        siteId: null
      },
      statusUnitMap: {},
      siteDeviceStatus: []
    }
  },
  computed: {
    importanceDeviceStatus () {
      let {statusUnitMap} = this
      if (!this.siteDeviceStatus.length) {
        return []
      }
      return this.siteDeviceStatus.map(el => {
        return {
          ...el,
          unit: statusUnitMap[el.deviceStatusId] ? statusUnitMap[el.deviceStatusId].unit : ''
        }
      })
    }
  },
  methods: {
    getDeviceStatusMap () {
      this.changeLoadStatus(true)
      this.$api.SiteDeviceStatus.getList().then(data => {
        let dataMap = data.reduce((map, el) => {
          if (!map[el.siteDeviceId]) {
            map[el.siteDeviceId] = []
          }

          if (el.isImportance && el.status) {
            map[el.siteDeviceId].push(el)
          }

          return map
        }, {})
        this.siteDeviceStatus = Object.values(dataMap).flat()
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    getDeviceStatus () {
      this.$api.DeviceStatus.getList().then(data => {
        this.statusUnitMap = data.reduce((map, el) => {
          if (el.status) {
            map[el.id] = el
          }

          return map
        }, {})
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    }
  },
  created () {
    this.getDeviceStatusMap()
    this.getDeviceStatus()
    this.$api.User.getMaxAuditStage().then(maxAuditStage => {
      this.maxAuditStage = maxAuditStage
    }).catch(console.error)
  },
  beforeDestroy () {
    this.$store.commit('Profile/showSideNav', true)
  }
}
</script>

<style scoped>
.audit-wrapper {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/02Data-Audit/01Manual/index.vue